/* eslint-disable indent */
import { Button, Card, Typography } from 'src/components/common';
import ProfilePicture from 'src/components/profile/profilePicture/ProfilePicture';
import { timeAgo } from 'src/utils';
import { useGetIdentity, useOpenInNewTab } from 'src/hooks';
import { useAppDispatch } from 'src/store/hooks';
import { useNavigate } from 'react-router-dom';
import MarkdownRenderer from 'react-markdown-renderer';
import {
  TRespondToCollaborationRequest,
  TRespondToEvaluationRequest,
  TRespondToKeyMemberSelectionRequest
} from 'src/services/apiEndpoint.types.ts';
import {
  respondToCollaborationRequest,
  respondToEvaluationRequest
} from 'src/store/ideaHub/ideaHub.slice';
import { respondToKeyMemberSelection } from 'src/store/program/program.slice';
import { updateInviteNotificationActionStatus } from 'src/store/notifications/notifications.slice';

import './inviteNotificationCard.scss';
import { TInviteNotificationCard } from './inviteNotificationCard.types';

import useGetNotificationTItle from '../useGetNotificationTItle/useGetNotificationTItle';
import { useState } from 'react';
import { test } from 'src/assets/images';
import { processMarkdown, processMarkdown2 } from 'src/constants/typography.constant';

const InviteNotificationCard = (notification: TInviteNotificationCard | any) => {
  // Hooks
  const getNotificationTitle = useGetNotificationTItle();
  const { getIdentities } = useGetIdentity();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { openInNewTab } = useOpenInNewTab();

  // Constants
  const { authenticatedId, loggedInUserType } = getIdentities();

  // Constants
  const { title, description } = getNotificationTitle({ notification });
  const notificationType = notification?.metadata?.notificationType;
  const { loggedInUserId } = getIdentities();

  let viewButtonText = '';
  if (notificationType === 'CollaborationRequest' || notificationType === 'EvaluationRequest') {
    viewButtonText = 'View Idea';
  } else if (notificationType === 'KeyMemberRequest' && notification?.metadata?.isEndUser) {
    viewButtonText = 'View company profile';
  } else if (notificationType === 'KeyMemberRequest' && !notification?.metadata?.isEndUser) {
    viewButtonText = 'View profile';
  } else if (notificationType === 'DemoInvite') {
    viewButtonText = 'Join Now';
  } else {
    viewButtonText = 'View Idea';
  }
  const acceptCollaborationRequest = () => {
    const payload: TRespondToCollaborationRequest = {
      ideaId: notification?.idea?.id,
      userId: loggedInUserId,
      status: 'Accepted'
    };

    dispatch(respondToCollaborationRequest(payload)).then((status: unknown) => {
      if ((status as unknown as number) === 200) {
        dispatch(
          updateInviteNotificationActionStatus({ id: notification?.id, actionTaken: 'Accepted' })
        );
      }
    });
  };

  const rejectCollaborationRequest = () => {
    const payload: TRespondToCollaborationRequest = {
      ideaId: notification?.idea?.id,
      userId: loggedInUserId,
      status: 'Rejected'
    };

    dispatch(respondToCollaborationRequest(payload)).then((status: unknown) => {
      if ((status as unknown as number) === 200) {
        dispatch(
          updateInviteNotificationActionStatus({ id: notification?.id, actionTaken: 'Rejected' })
        );
      }
    });
  };

  const acceptEvaluationRequest = () => {
    const payload: TRespondToEvaluationRequest = {
      ideaId: notification?.idea?.id,
      userId: loggedInUserId,
      status: 'Accepted'
    };

    dispatch(respondToEvaluationRequest(payload)).then((status: unknown) => {
      if ((status as unknown as number) === 200) {
        dispatch(
          updateInviteNotificationActionStatus({ id: notification?.id, actionTaken: 'Accepted' })
        );
      }
    });
  };

  const rejectEvaluationRequest = () => {
    const payload: TRespondToEvaluationRequest = {
      ideaId: notification?.idea?.id,
      userId: loggedInUserId,
      status: 'Rejected'
    };

    dispatch(respondToEvaluationRequest(payload)).then((status: unknown) => {
      if ((status as unknown as number) === 200) {
        dispatch(
          updateInviteNotificationActionStatus({ id: notification?.id, actionTaken: 'Rejected' })
        );
      }
    });
  };

  const acceptKeyMemberRequest = () => {
    const payload: TRespondToKeyMemberSelectionRequest = {
      companyId: notification?.company?.id,
      userId: loggedInUserId,
      status: 'Accepted'
    };

    dispatch(respondToKeyMemberSelection(payload)).then((status: unknown) => {
      if ((status as unknown as number) === 200) {
        dispatch(
          updateInviteNotificationActionStatus({ id: notification?.id, actionTaken: 'Accepted' })
        );
      }
    });
  };

  const rejectKeyMemberRequest = () => {
    const payload: TRespondToKeyMemberSelectionRequest = {
      companyId: notification?.company?.id,
      userId: loggedInUserId,
      status: 'Rejected'
    };

    dispatch(respondToKeyMemberSelection(payload)).then((status: unknown) => {
      if ((status as unknown as number) === 200) {
        dispatch(
          updateInviteNotificationActionStatus({ id: notification?.id, actionTaken: 'Rejected' })
        );
      }
    });
  };

  const [request, setRequest] = useState<string>('')
  const handleAccept = () => {
    if (notificationType === 'CollaborationRequest') {
      acceptCollaborationRequest();
      setTimeout(() => {
        setRequest('accepted')
      }, 1000)
    } else if (notificationType === 'EvaluationRequest') {
      acceptEvaluationRequest();
    } else if (notificationType === 'KeyMemberRequest') {
      acceptKeyMemberRequest();
    }
  };

  const handleReject = () => {
    if (notificationType === 'CollaborationRequest') {
      rejectCollaborationRequest();
    } else if (notificationType === 'EvaluationRequest') {
      rejectEvaluationRequest();
    } else if (notificationType === 'KeyMemberRequest') {
      rejectKeyMemberRequest();
    }
  };

  const handleViewButton = () => {
    if (notificationType === 'CollaborationRequest') {
      navigate(
        `/view-idea?id=${notification?.idea?.id}&tab=ideaDetails&collaborationType=Collaboration`
      );
    } else if (notificationType === 'EvaluationRequest') {
      navigate(
        `/view-idea?id=${notification?.idea?.id}&tab=ideaDetails&collaborationType=Evaluation`
      );
    } else if (notificationType === 'KeyMemberRequest' && notification?.metadata?.isEndUser) {
      navigate(`/view-company?id=${notification?.company?.id}`);
    } else if (notificationType === 'KeyMemberRequest' && !notification?.metadata?.isEndUser) {
      navigate(`/view-profile?id=${notification?.user?.id}`);
    } else {
      // maybe change after some time
      navigate(
        `/view-idea?id=${notification?.idea?.id}&tab=ideaDetails&collaborationType=Evaluation`
      );
    }
  };

  const openDemoInvite = () => {
    const url = notification?.demo?.conferenceLink;
    if (url) {
      openInNewTab({ url });
    }
  };

  const viewKeyMemberNotificationProfile = () => {
    if (notificationType === 'KeyMemberRequest' && notification?.metadata?.isEndUser) {
      navigate(`/view-company?id=${notification?.company?.id}`);
    } else if (notificationType === 'KeyMemberRequest' && !notification?.metadata?.isEndUser) {
      navigate(`/view-profile?id=${notification?.user?.id}`);
    }
  };
  console.log(notification, 'notificationData');
  function handleClick() {
    if (notification?.metadata?.notificationType === 'global-invite') {
      window.open(notification?.metadata?.url)
    } else if (notification?.metadata?.postId) {
      navigate(`/view-post?postId=${notification?.metadata?.postId}&viewAs=User`)
    } else if (notification?.metadata?.ventureId) {
      navigate(`/view-venture?id=${notification?.metadata?.ventureId}`)
    } else if (notification?.metadata?.notificationType === 'Follow' && notification?.user?.id) {
      if (authenticatedId === notification?.user?.id) {
        navigate(`/my-profile`)
      } else {
        navigate(`/view-profile?id=${notification?.user?.id}`)
      }
    } else if (notification?.metadata?.notificationType === 'Follow' && notification?.metadata?.companyId) {
      if (authenticatedId === notification?.metadata?.companyId) {
        navigate(`/my-company`)
      } else {
        navigate(`/view-company?id=${notification?.metadata?.companyId}`)
      }
    } else if (notification?.metadata?.notificationType === 'CollaborationRequest' && notification?.type === 'access-edit') {
      navigate(`/view-idea?id=${notification?.metadata?.ideaId}&tab=ideaDetails&collaborationType=Collaboration`)
    }
  }
  const isGlobal = notification?.metadata?.notificationType === 'global-invite'
  console.log(notification, 'notificationData');

  const isNotificationActionButton = (
    notification?.notificationTab === 'invite' &&
    notification?.actionTaken === 'Pending'
  ) || (notification?.actionTaken === 'Accepted' ||
    notification?.actionTaken === 'Complete') ||
    (notificationType === 'KeyMemberRequest' &&
      notification?.actionTaken === 'Rejected') ||
    notification?.metadata?.notificationType === 'DemoInvite'
  const processedValue = title && isGlobal ? processMarkdown2(title) : '';
  console.log(processedValue, 'processedValue');
  
  return (
    <Card className="invite-notifications-card" onClick={handleClick} style={notification.new ? { background: '#ffe5d536', cursor: 'pointer' } : { cursor: 'pointer' }}>
      <div className="invite-notifications-card__body__container">
        <ProfilePicture
          className="invite-notifications-card__body__container__profile-pic"
          url={notification?.user?.profilePic || notification?.company?.logo}
          fallback={notification?.user?.name?.[0] || notification?.company?.name?.[0] || 'H'}
        />

        <div className="invite-notifications-card__body__container__body">
          {title && <Typography
            className="invite-notifications-card__body__container__body__title"
            as="span"
            variant="body-2"
            fontWeight="semiBold"
            title={title}
          >
            {/* {isGlobal ? <MarkdownRenderer markdown={processedValue} break={true} /> : title} */}
            {!isGlobal ? title : ''}
            {isGlobal ? <div dangerouslySetInnerHTML={{ __html: processedValue }} /> : ''}
          </Typography>}
          {description && <Typography
            className="invite-notifications-card__body__container__body__title"
            as="span"
            variant="caption"
            fontWeight="regular"
            title={description}
          >
            {description}
          </Typography>}
          <Typography
            className="invite-notifications-card__body__container__timestamp"
            as="p"
            variant="caption"
            fontWeight="regular"
          >
            {timeAgo({ timestamp: notification?.updatedAt || '' })}
          </Typography>
          {isNotificationActionButton && (
            <div className="invite-notifications-card__body__container__body__actions">
              {notification?.notificationTab === 'invite' &&
                notification?.actionTaken === 'Pending' && (
                  <Button variant="primary" size="extraSmall" onClick={handleAccept}>
                    Accept
                  </Button>
                )}
              {notification?.notificationTab === 'invite' &&
                notification?.actionTaken === 'Pending' && (
                  <Button variant="secondary" size="extraSmall" onClick={handleReject}>
                    Reject
                  </Button>
                )}
              {(notification?.actionTaken === 'Accepted' ||
                notification?.actionTaken === 'Complete') && (
                  <Button variant="secondary" size="extraSmall" onClick={handleViewButton}>
                    {viewButtonText}
                  </Button>
                )}
              {notificationType === 'KeyMemberRequest' &&
                notification?.actionTaken === 'Rejected' && (
                  <Button
                    variant="secondary"
                    size="extraSmall"
                    onClick={viewKeyMemberNotificationProfile}
                  >
                    View Profile
                  </Button>
                )}
              {notification?.metadata?.notificationType === 'DemoInvite' && (
                <Button variant="primary" size="extraSmall" onClick={openDemoInvite}>
                  Join Now
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
      {notification?.image && <div className='invite-notifications-card__image'>
        <img src={notification?.image} alt="media-image" />
      </div>}
    </Card>
  );
};

export default InviteNotificationCard;
